module.exports = __webpack_public_path__ + "img/obs_water_danger_up.17a857f0.svg";